<template>
  <v-app>
    <v-content class="grey lighten-2">
      <v-container fluid class="view-container remove-space-on-print remove-shadow-on-print">
        <notifications v-if="$vuetify.breakpoint.smAndDown" group="app" position="bottom center"/>
        <notifications v-else group="app" position="top right"/>
        <v-slide-y-transition mode="out-in" v-cloak>
          <router-view/>
        </v-slide-y-transition>
        <div class="hide-on-print">
          <v-footer id="footer" class="grey lighten-2 text-xs-center">
            <img src="./assets/brasao.png" alt="Brasão do estado de rondônia">
            <p>Tribunal de Justiça do Estado de Rondônia</p>
          </v-footer>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    data() {
      return {
        title: 'Consulta Pública de Selos e Atos'
      }
    },
    name: 'App'
  }
</script>

<style scoped>
  .view-container {
    max-width: 1140px;
  }

  #footer {
    width: 100%;
    display: inline-block;
  }

  #footer p {
    margin-bottom: 5px;
  }

  #footer img {
    height: 50px
  }
</style>


<style>
  .lista-dados b {
    display: block;
    margin-bottom: 5px;
  }

  .lista-dados span {
    font-weight: lighter;
  }

  .show-on-print {
    display: none !important;
  }

  @media print {
    .elevation-7 {
      box-shadow: none !important;
    }

    .hide-on-print {
      display: none !important;
    }

    .remove-space-on-print, .flex {
      margin: 0;
      padding: 0;
      border: none;
      font-size: 10px;
    }

    .remove-shadow-on-print {
      box-shadow: none !important;
    }

    .white--text {
      color: #000 !important;
      caret-color: #000 !important;
      background-color: #fff !important;
    }

    .v-toolbar, .flex {
      box-shadow: none !important;
    }

    .v-toolbar__content {
      height: 25px !important;
    }

    .v-toolbar__title {
      font-size: 17px;
    }

    .print-card {
      margin: 0;
      padding: 5px 10px;
      border: 1px solid #000;
      font-size: 10px;
      box-shadow: none !important;
    }

    .print-card .v-toolbar__title {
      font-size: 15px;
    }

    .fix-margin-print {
      margin: 0;
      padding: 5px;
    }

    .show-on-print {
      display: inherit !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue